import { OptionsApi } from '@core/swagger-client';
import { Button, ContainerNoTopSpace, ContainerWebinarInner, ErrorMessage, ErrorMessagePage, Heading, Input, Loader, WarningOutlined } from '@core/ui';
import { dropOverviewLists, getOverviewTarget, useNavigate, useParams } from '@online-webinar/router';
import { BackToOriginLink } from '@online-webinar/ui-frontend';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const DeleteWebinarPage = () => {
    const [confirmCode, setConfirmCode] = useState('');
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { webinarId } = useParams({ strict: false });
    const { t } = useTranslation();

    const { isLoading: webinarIsLoading, data: webinar, error: webinarError } = useQuery(OptionsApi.dashboard.getContentSummary(webinarId!));
    const { isLoading: deleteCodeIsLoading, data: deleteCode, error: deleteCodeError } = useQuery(OptionsApi.webinar.getDeleteCode(webinarId!));

    const deleteWebinarMutation = useMutation(OptionsApi.webinar.delete());
    const deleteWebinar = () => {
        deleteWebinarMutation.mutate(
            {
                webinarId: webinarId!,
                deleteCode: confirmCode
            },
            {
                onSuccess: () => {
                    dropOverviewLists(queryClient);
                    navigate(getOverviewTarget());
                }
            }
        );
    };

    const isLoading = webinarIsLoading || deleteCodeIsLoading;
    const error = webinarError || deleteCodeError;
    if (error) {
        return <ErrorMessagePage apiError={error} />;
    }

    return (
        <ContainerNoTopSpace>
            <ContainerWebinarInner>
                <BackToOriginLink fallback="content" />
                {webinar && (
                    <>
                        <Heading variant="h1" classNames="mb-8 md:mb-10">
                            {t('Webinar.Delete.PageHeading')}
                        </Heading>
                        <div className="max-w-4xl bg-white bg-side-warning bg-no-repeat rounded-lg flex flex-col items-start gap-1 pl-6 md:pl-8 pr-4 md:pr-6 pt-4 pb-6 z-10">
                            <WarningOutlined classNames="w-10 fill-warning mb-2" />
                            <Heading variant="h2" styleAs="h3">
                                {t('Webinar.Delete.Warning')}
                            </Heading>
                            <p className="my-4">
                                <span className="font-w-heading font-accent text-xl">{webinar.title}</span>
                                {/*<WebinarDateTime broadcastDateTime={broadcastDateTime} />*/}
                            </p>
                            <p>
                                {t('Webinar.Delete.DeleteCode')}
                                <span className="max-w-sm bg-gray-200 rounded-lg block my-4 p-4 mg:px-6 text-center">{deleteCode}</span>
                                <div className="w-full max-w-sm">
                                    <Input
                                        type="text"
                                        label={t('Webinar.Delete.Deletecode.Label')}
                                        value={confirmCode}
                                        onChange={(e) => setConfirmCode(e.target.value)}
                                    />
                                    <Button variant="warning" isLoading={deleteWebinarMutation.isPending} onClick={deleteWebinar}>
                                        {t('Webinar.Button.Delete')}
                                    </Button>
                                </div>
                            </p>
                        </div>
                    </>
                )}
                {deleteWebinarMutation.error && <ErrorMessage apiError={deleteWebinarMutation.error} />}
                {isLoading && <Loader classNames="m-auto" />}
            </ContainerWebinarInner>
        </ContainerNoTopSpace>
    );
};
